import React from 'react'
import ReactMarkdown from 'react-markdown'
import styled from 'styled-components'
import media from '../../utils/media'
import Text from '../../utils/Text'

const TextComponent = styled.div`
  text-align: ${props =>
    props.textAlign ? props.textAlign : 'center'};
  margin-bottom: ${props => (props.marginB ? props.marginB : 28)}px;
  ${media.mobileL`
    margin-bottom: ${props => (props.marginB ? props.marginB : 18)}px;
    text-align: ${props => props.textAlignMobile ?? props.textAlign};
    padding: ${props => props.paddingMobile ?? props.padding};
  `};
  padding: ${props => (props.padding ? props.padding : 0)};

  p {
    font-family: ${props =>
      props.fontFamily ? props.fontFamily : "'Raleway', sans-serif"};
    color: ${props =>
      props.fontColor ? props.fontColor : '#414141'};
    font-size: ${props => (props.fontSize ? props.fontSize : 35)}px;
    line-height: ${props =>
      props.lineHeight ? props.lineHeight : 1.5};
    letter-spacing: ${props =>
      props.letterSpacing ? props.letterSpacing : 'normal'};
    font-weight: ${props => props.textFontWeight ?? 400};

    strong {
      display: inline;
      font-weight: ${props => props.fontWeight ?? 400};
    }
  }
`

export default function Paragraph({ ...props }) {
  const {
    paragraph,
    content,
    fontSize,
    textAlign,
    textAlignMobile,
    fontColor,
    letterSpacing,
    lineHeight,
    marginB,
    padding,
    paddingMobile,
    fontFamily,
    classN,
    textFontWeight,
    fontWeight,
  } = props

  return (
    <TextComponent
      className={classN}
      marginB={marginB}
      padding={padding}
      paddingMobile={paddingMobile}
      fontSize={fontSize}
      textAlign={textAlign}
      textAlignMobile={textAlignMobile}
      fontColor={fontColor}
      fontFamily={fontFamily}
      lineHeight={lineHeight}
      fontWeight={fontWeight}
      textFontWeight={textFontWeight}
      letterSpacing={letterSpacing}
    >
      {paragraph && <Text id={paragraph} markdown />}
      {content && <ReactMarkdown source={content} />}
    </TextComponent>
  )
}
